import React from 'react';
import {Col, Row} from 'antd';
import ThisMonthSizeDashBoard from "./ThisMonth/ThisMonthSizeDashBoard";
import ThisQuarterSizeDashBoard from "./Quarter/ThisQuarterSizeDashBoard";
import ThisYearSizeDashBoard from "./Year/ThisYearSizeDashBoard";
import TodaySizeDashBoard from "./Today/TodaySizeDashBoard";

const FileMgrDashBoard: React.FC = () => {
    const getColProps = () => {
        const baseProps = {xs: 24, sm: 12, md: 12, lg: 12, xl: 12, xxl: 12};
        return baseProps;
    }

    return (
        <Row gutter={[16,16]}>
            <Col {...getColProps()}>
                <TodaySizeDashBoard/>
            </Col>
            <Col {...getColProps()}>
                <ThisMonthSizeDashBoard/>
            </Col>
            <Col {...getColProps()}>
                <ThisQuarterSizeDashBoard/>
            </Col>
            <Col {...getColProps()}>
                <ThisYearSizeDashBoard/>
            </Col>
        </Row>
    );
};

export default FileMgrDashBoard;
